import { NavLink } from 'react-router';
import { PropsWithChildren } from 'react';
import styles from './Tabs.module.css';
import classNames from 'classnames';

function Root({ children }: PropsWithChildren) {
  return <nav className={styles.tabs}>{children}</nav>;
}

function Tab({ children, to }: { to: string } & PropsWithChildren) {
  return (
    <NavLink className={({ isActive }) => classNames(styles.tab, { [styles.active]: isActive })} to={to}>
      {children}
    </NavLink>
  );
}

export const Tabs = Object.assign(Root, {
  Tab,
});
